var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c(
        "div",
        [
          _vm.showTitle ? _c("siteNav") : _vm._e(),
          _c("div", { staticClass: "layout" }, [_c("router-view")], 1),
          _vm.showTitle ? _c("Footer") : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }